import React from 'react';
import './paginacao.css';


export default class Paginacao extends React.Component{
  constructor(props){
    super(props);
    this.pageHandler = this.pageHandler.bind(this);
  }

  pageHandler(e, val){
    e.preventDefault();

    this.props.pageHandler(val);
  }

  render(){
    const data = this.props.data;
    const atual = data ? Number(data.current) : '';
    const max = data ? Number(data.maxPage) : '';
    const maxResults = data ? Number(data.maxResults) : '';
    const left = atual===1 ? null :
    (<a href='#' onClick={(e) => this.pageHandler(e,atual-1)}>
      <i className="fas fa-chevron-left"></i>
      <span>Anterior</span>
    </a>);
    const right = atual === max ? null :
    (
      <a href='#' onClick={(e) => this.pageHandler(e,atual+1)}>
        <span>Próximo</span>
        <i className="fas fa-chevron-right"></i>
      </a>
    );

    return(
      <div className='paginacao'>
        {left}
        <span className='page-txt'>{`Exibindo ${atual} de ${max} páginas (${maxResults} itens)`}</span>
        {right}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/paginacao/Paginacao.js